/* src/app/forms/importacao-dados/importacao-dados.component.scss */
.mat-mdc-tab-body.mat-tab-body-active {
  height: 60vh;
}
.block {
  animation: 1s fadeIn;
  animation-fill-mode: forwards;
  opacity: 0;
  animation: fadeIn 10s;
  animation-delay: 40s;
  animation-fill-mode: forwards;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.content {
  padding: 5px;
  height: 100%;
  display: flex;
  flex-direction: row;
  width: 100%;
}
.mktplace {
  overflow: auto;
  height: 100%;
}
.toogleTest {
  margin-left: 14px;
  margin-top: 6px;
}
.gridclass {
  height: 100%;
  width: 100%;
  position: absolute;
}
.mat-tab-body-content {
  height: auto !important;
}
.tabcontent {
  height: 100%;
  overflow-y: auto;
}
.cardcontent {
  height: 25%;
}
.my-button-class {
  height: 36px;
  line-height: 36px;
}
.margin-top10 {
  margin-top: 10px;
}
.align-items {
  align-items: center;
}
.mat-mdc-tab-group {
  height: 100%;
}
:host ::ng-deep .custom-tabs {
}
:host ::ng-deep .custom-tabs .mat-tab-body-wrapper {
  height: 100%;
}
.transformimage {
  transform: scale(1.5);
}
.title {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 80% !important;
}
.button-margin {
  margin-right: 10px;
  margin-bottom: 5px;
}
.mat-toolbar {
  background: color-mix(in srgb, var(--tem-ink) 3%, transparent);
}
.combined-tab .mat-tab-body-wrapper {
  display: flex;
}
.combined-tab .mat-tab-body-wrapper > div {
  flex: 1;
}
.mat-grid-tile {
  display: flex;
  justify-content: center;
}
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.grid-container {
  flex: 1;
  display: flex;
}
.grid-item {
  flex: 1;
}
.view-component-tab {
  display: flex;
  flex-direction: row;
  height: 100%;
  gap: 10px;
  width: 100%;
  position: relative;
}
.content-tab {
  flex: 1;
  display: flex;
  margin-top: 5px;
  position: relative;
}
.simple-datagrid {
  flex: 1;
}
.separator {
  height: 1px;
  background-color: #ccc;
  margin: 10px 0;
}
.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.config-info {
  display: flex;
  align-items: center;
  font-size: 114%;
}
.config-label {
  font-weight: bold;
  margin-right: 5px;
}
.config-values {
  color: #333;
}
.config-separator {
  margin: 0 5px;
  color: #777;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 5px;
}
.container-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  gap: 10px;
}
.config-container {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
}
.search-input-dados {
  width: 100%;
}
/*# sourceMappingURL=importacao-dados.component.css.map */
